export default "__VITE_ASSET__294807be__"